import caseResources from './cases'
import producerResources from './producers'
import prospectResources from './prospects'

export default {
  ...caseResources,
  ...producerResources,
  ...prospectResources
}
